import { render, staticRenderFns } from "./authorizationMsg.vue?vue&type=template&id=4e017f71&scoped=true&"
import script from "./authorizationMsg.vue?vue&type=script&lang=js&"
export * from "./authorizationMsg.vue?vue&type=script&lang=js&"
import style0 from "./authorizationMsg.vue?vue&type=style&index=0&id=4e017f71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e017f71",
  null
  
)

export default component.exports